export default __webpack_public_path__ + "static/media/icon-machingLearning.1ba6e81b.svg";